import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  gradientMainWelcomeSection,
  layoutContentMaxWidthPx,
} from '../../../../shared/style-settings'

export const useMainPageWelcomeSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    welcomeSection: {
      position: 'relative',
      background: gradientMainWelcomeSection,
      padding: theme.spacing(12, 3),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(10, 2.5),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(8, 2),
      },
    },
    welcomeHolder: {
      maxWidth: layoutContentMaxWidthPx,
      margin: '0 auto',
      display: 'flex',
      zIndex: 1,
      position: 'relative',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
    welcomeInfoHolder: {
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        paddingBottom: 20,
      },
    },
    welcomeIcon: {
      color: theme.palette.primary.light,
      fontSize: 'clamp(48px, 5vw + 2vh, 80px)',
      paddingRight: theme.spacing(1),
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(40px, 6vw, 64px)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(36px, 7vw, 56px)',
      },
    },
    welcomeText: {
      color: theme.palette.primary.dark,
      fontSize: 'clamp(16px, 1.5vw, 22px)',
      maxWidth: '75%',
      lineHeight: 1.9,
      fontWeight: 400,
      [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(15px, 2vw, 20px)',
        maxWidth: '80%',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(14px, 2.5vw, 18px)',
        maxWidth: '100%',
      },
    },
    welcomeBtnHolder: {
      flex: '0 0 220px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flex: '0 0 200px',
      },
      [theme.breakpoints.down('xs')]: {
        flex: '1 1 100%',
        marginTop: theme.spacing(2),
      },
    },
    welcomeBtn: {
      borderRadius: theme.shape.borderRadius * 2,
      display: 'block',
      padding: theme.spacing(1.75, 5),
      textTransform: 'initial',
      fontWeight: 600,
      fontSize: 'clamp(14px, 1.2vw, 18px)',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1.5, 4),
        fontSize: 'clamp(13px, 1.5vw, 17px)',
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1.5, 3.5),
        fontSize: 'clamp(13px, 1.8vw, 16px)',
      },
    },
    welcomeBgHolder: {
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      zIndex: 0,
    },
    welcomeBgIcon: {
      position: 'absolute',
      right: '30vw',
      fontSize: 'calc(300px)',
      color: theme.palette.primary.dark,
      opacity: '0.05',
      transform: 'scale(2)',
      transformOrigin: 'center',
    },
  })
)
